import React from 'react'
import { Route } from 'react-router'
import Callback from './auth/Callback'

const customRoutes = [<Route exact path="/callback" component={Callback} />]

export default customRoutes
